export default {
  container: {
    flexDirection: 'column',
  },
  label: {},
  textContainer: {},
  rejectionReasonText: {},
};
